import { FC } from 'react';

import { TokenBaseStaticSpace } from '@hh.ru/magritte-design-tokens/types';
import { Input } from '@hh.ru/magritte-ui';

import useTrls from 'hooks/translation/useTrls';

import { MagritteFormField } from 'components/common/MagritteFormField/MagritteFormField';

interface MagritteBannerTitleProps {
    value: string;
    onChange: (value: string) => void;
    vSpacingBottom?: TokenBaseStaticSpace;
    error?: string;
    dataQa?: string;
    label?: string;
    placeholder?: string;
}

const TrlKeys = {
    label: 'create.campaign.input.title.label',
    placeholder: 'create.campaign.input.title.placeholder',
};

const TITLE_MAX_LENGTH = 40;

export const MagritteBannerTitle: FC<MagritteBannerTitleProps> = ({
    value,
    error,
    onChange,
    dataQa,
    label,
    placeholder,
    vSpacingBottom,
}) => {
    const trl = useTrls();

    const restTitleLength = TITLE_MAX_LENGTH - value.length;

    return (
        <MagritteFormField
            label={label || trl(TrlKeys.label)}
            input={
                <Input
                    value={value}
                    onChange={onChange}
                    placeholder={placeholder || trl(TrlKeys.placeholder)}
                    invalid={!!error || restTitleLength < 0}
                    data-qa={dataQa || 'title-input'}
                    hint={restTitleLength < 0 && `${value.length}/${TITLE_MAX_LENGTH}`}
                    errorMessage={error}
                    clearableOnFocus
                />
            }
            vSpacingBottom={vSpacingBottom}
        />
    );
};
